import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import Layout from '~/components/Layout'
import { useAuth } from '~/routes/components/AuthProvider'
import { FilterWrapper } from '../style'
import { Dropdown } from 'semantic-ui-react'
import { DateInput } from 'semantic-ui-calendar-react'
import i18n from '~/components/i18n'
import TableComponent from '~/components/TableComponent'
import { FarmersService } from '~/api/services/farmers/index'
import { handleErrors } from '~/utils/helpers'

const getTableColumnHeaders = () => [
  {
    name: i18n.t('Content'),
    key: 'content'
  },
  {
    name: i18n.t('Mobile number'),
    key: 'mobileNumber'
  },
  {
    name: i18n.t('Status'),
    key: 'status'
  },
  {
    name: i18n.t('Date'),
    key: 'date',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm'
  },
  {
    name: i18n.t('Operator'),
    key: 'operator'
  }
]

const SMSLogs: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0,
    from: '',
    to: '',
    status: '',
    userId: ''
  })
  const [smsLogsData, setSmsLogsData] = useState(null)
  const [isBusy, setIsBusy] = useState(false)
  const [loadData, setLoadData] = useState(false)
  const [smsLogsOptions, setSmsLogsOptions] = useState(null)
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)

  useEffect(() => {
    fetchDataOptions()
  }, [t])

  useEffect(() => {
    if (!isBusy && smsLogsOptions) {
      fetchData()
    }
  }, [dataFiltered, isBusy, smsLogsOptions])

  async function fetchDataOptions() {
    setIsBusy(true)
    try {
      const responseOptions = await FarmersService.getSmsLogsOptions(id)
      setSmsLogsOptions(responseOptions.data)
      setDataFiltered({
        ...dataFiltered,
        userId: responseOptions.data?.users?.length > 0 ? responseOptions.data?.users[0]?.id : ''
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  async function fetchData() {
    setLoadData(true)
    try {
      const response = await FarmersService.getSmsLogs(id, {
        ...dataFiltered,
        page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
      })
      setSmsLogsData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setLoadData(false)
  }

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  function renderFilters() {
    return <FilterWrapper>
      <Dropdown
        clearable
        selection
        selectOnBlur={false}
        value={dataFiltered.userId}
        options={smsLogsOptions?.users?.map(user => ({ value: user.id, text: user.name })) || []}
        placeholder={t('Select user...')}
        scrolling
        onChange={(_, data) => setDataFiltered({
          ...dataFiltered,
          userId: data.value as string,
          page: 0
        })}
      />
      <Dropdown
        selection
        clearable
        selectOnBlur={false}
        value={dataFiltered.status}
        scrolling
        options={smsLogsOptions?.statuses?.map(emailOption => ({ value: emailOption.key, text: emailOption.label })) || []}
        placeholder={t('Select status...')}
        onChange={(_, data) => setDataFiltered({
          ...dataFiltered,
          status: data.value as string,
          page: 0
        })}
      />
      <DateInput
        name='date'
        autoComplete='off'
        placeholder={t('Date from')}
        closable
        clearIcon={'close'}
        clearable
        localization={languageLocal.code}
        closeOnMouseLeave={false}
        dateFormat={'DD.MM.YYYY'}
        className={'datePicker'}
        value={dataFiltered.from}
        onKeyPress={handleKeyPress}
        iconPosition='left'
        onChange={(event, { name, value }) => setDataFiltered({
          ...dataFiltered,
          from: value,
          page: 0
        })}
      />
      <DateInput
        name='date'
        autoComplete='off'
        placeholder={t('Date to')}
        closable
        clearIcon={'close'}
        clearable
        onKeyPress={handleKeyPress}
        localization={languageLocal.code}
        closeOnMouseLeave={false}
        dateFormat={'DD.MM.YYYY'}
        className={'datePicker'}
        minDate={dataFiltered.from}
        value={dataFiltered.to}
        iconPosition='left'
        onChange={(event, { name, value }) => {
          setDataFiltered({
            ...dataFiltered,
            to: value,
            page: 0
          })
        }}
      />
    </FilterWrapper>
  }

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={getTableColumnHeaders()}
      animated
      isFetchingData={loadData}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      upward={true}
      total={filtered}
    />
  }

  const { filtered, rows } = smsLogsData ? smsLogsData : { filtered: 0, rows: [] }

  return <Layout
    title={t('SMS logs')}
    childContainerSize={'auto'}
    useSpinner
    isBusy={isBusy}
    filters={renderFilters()}
  >
    {renderTable()}
  </Layout>
}
export default SMSLogs